import React from "react";
import { Link, graphql, useStaticQuery } from "gatsby";

const query = graphql`
  {
    allStrapiIndustry(sort: { fields: strapiId, order: DESC }, limit: 4) {
      nodes {
        title
        slug
        desc
        content
        strapiId
        date
        image {
          childImageSharp {
            fixed {
              src
            }
          }
        }
      }
    }
  }
`;

const News = () => {
  const data = useStaticQuery(query);
  const {
    allStrapiIndustry: { nodes: industries },
  } = data;

  const [fIndustry, ...rIndustry] = industries || [];
  return (
    <section className="featured-services-area pt-70 pb-70 bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-sm-6 col-md-6">
            <aside className="widget-area">
              <div className="widget widget_recent_courses">
                <h3 className="widget-title">新闻动态</h3>
                <div className="single-events-box rounded">
                  <div className="image p-0 h-auto">
                    <Link to={`/industry/${fIndustry.strapiId}`} className="d-block">
                      <img src={fIndustry.image.childImageSharp.fixed.src} className="w-100" alt="event" />
                    </Link>
                  </div>

                  <div className="content">
                    <h3>
                      <Link to={`/industry/${fIndustry.strapiId}`}>{fIndustry.title}</Link>
                    </h3>
                  </div>
                </div>
              </div>
            </aside>
          </div>
          <div className="col-lg-7 col-md-12">
            <aside className="widget-area">
              <div className="widget widget_recent_courses pt-5">
                {(rIndustry || []).map((industry, key) => (
                  <article className="item d-flex" key={key}>
                    <div className="info pr-2">
                      <Link to={`/industry/${industry.strapiId}`}>{industry.title}</Link>
                      <p className="title usmall text-truncate-multi-line">{industry.desc}</p>
                    </div>
                    <Link to={`/industry/${industry.strapiId}`} className="thumb flex-none" style={{ float: "none", flex: "0 0 auto" }}>
                      <img src={industry.image.childImageSharp.fixed.src} alt={industry.title} style={{ height: "100%" }} />
                    </Link>
                  </article>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default News;
